import styled from 'styled-components';

interface StyledContainerProps {
  $bgColor?: string;
}

const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  background-color: ${props => props.$bgColor || ''};

  
`;

export default StyledContainer;